import { render, staticRenderFns } from "./OrderType.vue?vue&type=template&id=0dc8f24b&scoped=true"
import script from "./OrderType.vue?vue&type=script&lang=js"
export * from "./OrderType.vue?vue&type=script&lang=js"
import style0 from "./OrderType.vue?vue&type=style&index=0&id=0dc8f24b&prod&lang=scss&scoped=true"
import style1 from "./OrderType.vue?vue&type=style&index=1&id=0dc8f24b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc8f24b",
  null
  
)

export default component.exports